export const MODAL_TYPE = {
  BOARD: 'Portfolio',
  PROJECT: 'Project',
  PHASE: 'Phase',
  ACTIVITY_PHASE: 'Work Category',
  MILESTONE: 'Milestone'
};
